import { isFunction } from "lodash";
import { useCallback, useState } from "react";
import { MdChevronLeft, MdInfo } from "react-icons/md";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  disabled = false,
  nextText = "Continuer",
  backText = "Retour",
  nextProps = {},
  backProps = {},
  infoText,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const externalLoading = Boolean(nextProps.loading);

  const isLoading = isSubmitting || externalLoading;
  const isNextDisabled =
    disabled || nextProps.disabled || isSubmitting || externalLoading;

  const handleNext = useCallback(async () => {
    if (!isFunction(onNext) || isNextDisabled) return;

    setIsSubmitting(true);
    try {
      await Promise.resolve(onNext());
    } finally {
      setIsSubmitting(false);
    }
  }, [isNextDisabled, onNext]);

  return (
    <div className="acoris__actions">
      {isFunction(onBack) && (
        <Button
          type="primary--link"
          className="acoris__actions--back"
          onClick={onBack}
          disabled={isSubmitting || backProps.disabled}
          {...backProps}
        >
          <MdChevronLeft size={24} />
          <span>{backText}</span>
        </Button>
      )}
      {isFunction(onNext) && (
        <div className="acoris__actions--primary">
          <Button
            block
            type="primary"
            className="acoris__actions--next"
            onClick={handleNext}
            {...nextProps}
            disabled={isNextDisabled}
            loading={isLoading}
          >
            {nextText}
          </Button>
          {infoText && (
            <div className="acoris__actions--info">
              <MdInfo size={24} />
              <p dangerouslySetInnerHTML={{ __html: infoText }} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionButtons;
